// extracted by mini-css-extract-plugin
module.exports = {"scoreTitle":"Label_scoreTitle__IDKOM"};